export const activities = {
  apply_filters_button: 'Apply filters',
  date_from: 'From {from}',
  date_from_to: 'From {from} to {to}',
  date_to: 'To {to}',
  filter_activity_type_legend: 'Event type',
  filter_discipline_legend: 'Discipline',
  filter_end_date_label: 'To',
  filter_selection_legend: 'Selection activity',
  filter_selection_no_label: 'No',
  filter_selection_yes_label: 'Yes',
  filter_start_date_label: 'From',
  selection_activity_tooltip: 'Selection activity',
  show_filters_button: 'Show filters',
  view_more: 'View more',
  event_description: 'Activity description',
  date_and_time: 'Date and time',
  location: 'Location',
  file_name: 'NAME',
  file_date: 'DATE',
  file_size: 'SIZE',
}



// WEBPACK FOOTER //
// ./src/server/i18n/en/activities.js